module.exports = __webpack_public_path__ + "static/img/fz_lhb_tb.adc8c22.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/fz_lhb_tb.png
// module id = 6rpy
// module chunks = 0